<template>
  <div class="message-quote" v-if="quoteMessage">
    <div
      class="quote-content multiline-ellipsis"
      :class="{
        'quote-content-img': quoteMessage.type === 'image',
      }"
    >
      <span class="quote-sender">{{ quoteMessage.nick || "未知" }}:</span>
      <!-- 文本消息 -->
      <span
        class="text-message"
        v-if="quoteMessage.type === 'text'"
        key="text-message"
      >
        <template
          v-for="(item, index) in quoteMessage?.showContext?.text || []"
        >
          <!-- eslint-disable-next-line prettier/prettier -->
          <a
            v-if="isUrl(item.text)"
            :href="item.text"
            target="_blank"
            :key="'url-' + index"
            >{{ item.text }}</a
          >
          <span
            v-else-if="item.name === 'text'"
            class="text-content"
            :key="'text-' + index"
            >{{ item.text }}</span
          >
          <img
            v-else-if="item.name === 'img'"
            class="text-img"
            :src="item.src"
            :key="'img-' + index"
          />
        </template>
      </span>
      <!-- 文件消息 -->
      <span
        v-else-if="quoteMessage.type === 'file'"
        class="quote-text"
        key="quote-text"
        >{{ quoteMessage?.showContext?.name || "[文件]" }}</span
      >
      <!-- 图片消息 -->
      <el-image
        v-else-if="quoteMessage.type === 'image'"
        class="quote-img"
        :src="quoteMessage?.showContext?.url"
        :preview-src-list="[quoteMessage?.showContext?.url]"
        :fit="'contain'"
      >
      </el-image>
    </div>
    <!-- 文件图标 -->
    <img
      v-if="quoteMessage.type === 'file'"
      class="file-icon"
      :src="fileTypeIcon"
      alt=""
    />
    <!-- 关闭按钮 -->
    <div
      class="quote-close"
      v-if="showCloseButton"
      @click.stop="handleCancelQuote"
    >
      <img src="../../../assets/images/live-chat/close-icon.png" alt="" />
    </div>
  </div>
</template>

<script>
import { fileImagebyFileName } from "@saas/components";
export default {
  name: "MessageQuote",
  props: {
    quoteMessage: {
      type: Object,
      default: null,
    },
    showCloseButton: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    fileTypeIcon() {
      return fileImagebyFileName(this.quoteMessage?.showContext?.name);
    },
  },
  methods: {
    // 判断一个字符串是否是链接
    isUrl(str) {
      if (!str) return false;
      return /^(https?|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/.test(
        str
      );
    },
    handleCancelQuote() {
      this.$emit("cancel-quote");
    },
  },
};
</script>

<style lang="scss" scoped>
.message-quote {
  background: #202022;
  border-radius: 8px;
  padding: 6px;
  width: fit-content;
  max-width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;

  font-weight: 500;
  font-size: 12px;
  color: #86909c;
  line-height: 16px;

  // 文本消息
  .text-message {
    .text-img {
      width: 18px;
      height: 18px;
      display: inline-block;
    }
    .text-box {
      white-space: pre-wrap;
      font-size: inherit;
      word-break: break-word;
      line-break: anywhere;
    }
    a {
      color: #386bff;
    }
  }

  .file-icon {
    width: 20px;
    height: 20px;
    margin-left: 6px;
  }

  ::v-deep .quote-img {
    max-width: 250px;
    max-height: 32px;
    .el-image__preview {
      max-width: 250px;
      max-height: 32px;
    }
  }
  .quote-content {
    flex: 1;
    &.quote-content-img {
      display: flex;
      align-items: flex-start;
    }
  }

  .quote-close {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 6px;
    cursor: pointer;
    width: 14px;
    height: 14px;

    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
